import React, { ComponentProps, FC } from "react";
import classNames from "classnames";

type ButtonProps = {
  as?: "button" | "a";
  width?: "fullWidth" | "fullWidthMobile";
};

const Button: FC<
  ButtonProps & ComponentProps<"a"> & ComponentProps<"button">
> = ({ children, as = "button", width, ...props }) => {
  const className = classNames("btn-primary btn-primary--csc", {
    "btn-primary--block": width === "fullWidth",
    "btn--xs-block": width === "fullWidthMobile",
  });

  switch (as) {
    case "a":
      return (
        <a className={className} {...props}>
          {children}
        </a>
      );
    case "button":
    default:
      return (
        <button className={className} {...props}>
          {children}
        </button>
      );
  }
};

export default Button;
